import React,{useState,useEffect,useCallback} from "react";

import {
    FaComment,
    FaRegComment,
    FaCheckCircle,
    FaRegCheckCircle,
    FaTimesCircle
} from 'react-icons/fa';
import {toast} from 'react-toastify';
import {Container,ContainerLoading,Content,Form,Table} from './styles';

import { SpaceLoader } from "../../../loaders/spaceLoader";
import { TelInput } from "../../../inputMasks";

import { useAdministrativeContext } from "../../../../pages/administrativePanel/administrativePanelContext";
import moment from 'moment';
import {api} from '../../../../services/api';

export function PersonLine(){

    const {
        listBusinessToFilter
    } = useAdministrativeContext();

    const [name,setName] = useState('');
    const [phone,setPhone] = useState('');
    const [business,setBusiness] = useState('');
    const [numPersons,setNumPersons] = useState('');
    const [status,setStatus] = useState('A')
    const [loading,setLoading] = useState(true);
    const [persons,setPersons] = useState([]);

    useEffect(() => {
        async function loadPersonList(){
            setLoading(true);
            if(listBusinessToFilter.length > 1){
                toast.error('Por favor, selecione somente uma empresa')
                setLoading(false)
                return
            }

            try{
                const response = await api.get(`getPersonInLine/${localStorage.getItem('@Inoveclube:token')}/${listBusinessToFilter.join()}/?status=${status}&name=`);

                setPersons(response.data.data);
                setBusiness(response.data.business);
                setLoading(false);
            }
            catch(error){
                toast.error(error.response.data.error);
                setLoading(false);
            }
        }
        loadPersonList();
    },[status,listBusinessToFilter]);

    const handleAdd = useCallback(async () => {
        setLoading(true);
        if(name.trim() === '' || phone.trim() === '' || numPersons.trim() === ''){
            toast.error('Preencha todos os campos !');
            setLoading(false);
            return
        }

        if(!Number(numPersons)){
            toast.info('Digite um número válido de pessoas');
            setLoading(false);
            return
        }

        try{
            const response = await api.post('/registerPersonInLine',{
                idBusiness: listBusinessToFilter,
                name: name,
                phone: phone,
                number: numPersons
            },  
            {
                headers: {
                    'Content-Type': 'application/json',
                     token: localStorage.getItem('@Inoveclube:token')
                }
            })

            const promise = await api.get(`getPersonInLine/${localStorage.getItem('@Inoveclube:token')}/${listBusinessToFilter.join()}/?status=A&name=`);
            setPersons(promise.data.data);
            setBusiness(promise.data.business);
            setStatus('A');
            
            setName('');
            setNumPersons('');
            setPhone('');
            setLoading(false);
            toast.success(response.data.message);
        }
        catch(error){
            setLoading(false);
            toast.error('Erro ao cadastrar pessoa na fila');
        }
    },[name,numPersons,phone,listBusinessToFilter]);

    const handleCallUser = useCallback(async (item) => {
      try{
        const response = await api.put('/callCostumer',{
            id: item.id
        });

        const texto = `Olá ${item.nome}, a sua mesa na ${business} está disponível !`

        
        const url = `https://wa.me/55${item.telefone}?text=${texto}`
        const win = window.open(url,'_blank');
        win.focus();

        const promise = await api.get(`getPersonInLine/${localStorage.getItem('@Inoveclube:token')}/${listBusinessToFilter.join()}/?status=A&name=`);
        setPersons(promise.data.data);
        setBusiness(promise.data.business);
        setStatus('A');

        setLoading(false);
        toast.success(response.data.message);
     }
     catch(error){
        setLoading(false);
        toast.error(error.response.data.error)
     }
    },[business,listBusinessToFilter]);

    const handleConfirmUser = useCallback(async (id) => {
        setLoading(true);
        try{
            const response = await api.put('/confirmCostumer',{
                id
            });

            const newArr = persons.filter((item) => {
                return item.id !== id
            })
            setPersons(newArr)
            setLoading(false);
            toast.success(response.data.message);
        }
        catch(error){
            setLoading(false);
            toast.error(error.response.data.error)
        }
    },[persons]);

    const handleDeleteUser = useCallback(async (id) => {
        setLoading(true);
        try{
            const response = await api.put('/cancelCostumer',{
                id
            });

            const newArr = persons.filter((item) => {
                return item.id !== id
            })
            setPersons(newArr)

            setLoading(false);
            toast.info(response.data.message);
        }
        catch(error){
            setLoading(false);
            toast.error(error.response.data.error)
        }
    },[persons]);

    if(loading){
        return (
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <Form>
                <div className="form-register">
                    <input
                        placeholder="nome"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                    />

                    <TelInput
                        type="tel"
                        placeholder="telefone"
                        name="TelInput"
                        value={phone}
                        onChange={(event) => setPhone(event.target.value)}
                    ></TelInput>

                    <input
                        type={'number'}
                        placeholder="nº de pessoas"
                        value={numPersons}
                        onChange={(event) => setNumPersons(event.target.value)}
                    />
                    <button onClick={handleAdd}>Cadastrar</button>  
                </div>

                <div className="buttons-filter">
                    <div className="radio">
                        <input 
                                type={'radio'}
                                value={'A'}
                                onChange={(event) => setStatus(event.target.value)}
                                checked={status === 'A'}
                        />
                        
                        <label>
                            Aguardando
                        </label>
                    </div>

                    <div className="radio">      
                        <input 
                                type={'radio'}
                                value={'C'}
                                onChange={(event) => setStatus(event.target.value)}
                                checked={status === 'C'}
                        />

                        <label>
                            Confirmados
                        </label>
                    </div>

                    <div className="radio">
                        <input 
                            type={'radio'}
                            value={'D'}
                            onChange={(event) => setStatus(event.target.value)}
                            checked={status === 'D'}
                        />
                        
                        <label>
                            Cancelados
                        </label>
                    </div>
                </div>     
            </Form>
        
            <Content>
                <Table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Nome</th>
                            <th className="isNone">Telefone</th>
                            <th>Nº de Pessoas</th>
                            <th className="isNone">Data</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            persons?.map((item,index) => {
                                return(
                                    <tr key={item.id}>
                                        <td>{(index+1)}º</td>
                                        <td>{item.nome}</td>
                                        <td className="isNone">{item.telefone}</td>
                                        <td>{item.numero_pessoas}</td>
                                        <td className="isNone">{moment(item.data_cadastrado).format('DD/MM/YYYY HH:mm')}</td>
                                        <td className="last-column">
                                            {
                                                item.chamado ? 
                                                <button onClick={() => handleCallUser(item)}>
                                                    <FaComment
                                                    />
                                                </button>
                                                :
                                                <button onClick={() => handleCallUser(item)}>
                                                    <FaRegComment/>
                                                </button>
                                      
                                            }
                                            <button onClick={() => handleConfirmUser(item.id)}>
                                                {
                                                    item.status === 'C' ?
                                                        <FaCheckCircle className='svg-confirm'/>
                                                    :
                                                        <FaRegCheckCircle className='svg-confirm'/>
                                                }
                                                
                                            </button>
                                            
                                            <button onClick={() =>handleDeleteUser(item.id)}>
                                                <FaTimesCircle className="svg-delete"/>
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </Content>
        </Container>
    )
}